const CustomRow = ({
    col = 6,
    title,
    children,
}) => {
    return (
        <>
            <div className={`col-${col}`}>
                <p className="py-2">{title}</p>
            </div>
            <div className={`col-${col}`}>
                {children}
            </div>
        </>

    )
}

export default CustomRow